import React, { createContext, useContext } from 'react';

const PageContext = createContext();

export const PageProvider = ({ children, value }) => {
  return (
    <PageContext.Provider value={value}>
      {children}
    </PageContext.Provider>
  );
};

export const usePageContext = () => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error('usePageContext must be used within a PageProvider');
  }
  return context;
};